import VaultReportedAmountBase from './base/VaultReportedAmountBase';

/**
 * @class VaultReportedAmount
 * @extends VaultReportedAmountBase
 */
class VaultReportedAmount extends VaultReportedAmountBase {

}

export default VaultReportedAmount;
